module.exports = __webpack_public_path__ + "img/hero-desktop.a902c52e.png";